export default {
  providerListSpan: {
    display: 'block',
  },
  providerDisabled: {
    opacity: '.5',
  },
  providerSelectFormItem: {
    width: '100%',
  },
  providerHeader: {},
};
